import { api } from '@/helpers/api'

export default {
  state: {
    BAD_CREDENTIALS: 0,
    UNKNOWN_ACCOUNT: 1,
    INVALID_TOKEN: 2,
    INVALID_PARTNER_NUMBER: 3,
    NOT_ACTIVATED: 4
  },
  login (emailAddress, password) {
    let data = {
      emailAddress,
      password
    }

    return api.post('user/auth/emailAddress', data).then(response => {
      return Promise.resolve(response.data)
    }).catch(error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            return Promise.reject(this.state.BAD_CREDENTIALS)
            
          case 410:
            return Promise.reject(this.state.UNKNOWN_ACCOUNT)
          
          case 423:
            return Promise.reject(this.state.NOT_ACTIVATED)
        }
      }

      // remove user password from error report
      error.config.data = error.config.data.replace(/"password":\s*"[^"]+"/, '"password":"[SECRET]"')

      return Promise.reject(error)
    })
  },
  loginWithPartner(partnerNumber, birthDate, postalCode) {
    let data = {
      number: partnerNumber,
      birthDate: birthDate,
      postalCode: postalCode
    }

    return api.post('user/auth/partner', data).then(response => {
      return Promise.resolve(response.data)
    }).catch(error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            return Promise.reject(this.state.BAD_CREDENTIALS)
            
          case 410:
            return Promise.reject(this.state.UNKNOWN_ACCOUNT)
          
          case 423:
            return Promise.reject(this.state.NOT_ACTIVATED)
        }
      }

      // remove sensitive data from error report
      error.config.data = error.config.data.replace(/"birthDate":\s*"[^"]+"/, '"birthDate":"[SECRET]"')
      error.config.data = error.config.data.replace(/"postalCode":\s*"[^"]+"/, '"postalCode":"[SECRET]"')

      return Promise.reject(error)
    })
  },
  refreshToken () {
    return api.get('user/auth/refresh', { userCheck: false }).then(response => Promise.resolve(response.data))
  },
  exchangeToken () {
    return api.get('user/auth/exchange').then(response => Promise.resolve(response.data))
  },
  getHistory () {
    return api.get('user/history').then(response => Promise.resolve({
      data: response.data.data.map(i => ({
        active: i.active,
        changeTime: new Date(i.changeTime),
        comment: i.comment,
        reference: i.reference,
        username: i.username
      }))
    }))
  },
  getLatestChange () {
    return api.get('user/history/latest').then(response => Promise.resolve({
      data: response.data.data.map(i => ({
        active: i.active,
        changeTime: new Date(i.changeTime),
        comment: i.comment,
        reference: i.reference,
        username: i.username
      }))
    }))
  },
  sendPasswordMail (email) {
    let data = {
      email
    }

    return api.post('legacy/api/v1/portal/login/sendPasswordForgottenMail', data)
  }
}